import { Theme } from "@material-ui/core";

export const styles = (theme: Theme) => ({
  divider: {
    backgroundColor: theme.palette.common.white,
    marginBottom: 10,
    marginTop: 10,
  },
  gritLogo: {
    marginTop: "0.5rem",
  },
  innerSidebar: {
    height: "100%",
    padding: 10,
    width: "100%",
  },
  linkContainer: {
    width: "100%",
  },
  schoolLogo: {
    height: 50,
    width: 50,
  },
  sidebar: {
    height: "100%",
    overflow: "hidden",
  },
  sidebarBackground: {
    backgroundSize: "cover",
    height: "100%",
  },
  text: {
    ...theme.typography.button,
    color: "white",
  },
});



// WEBPACK FOOTER //
// ./src/pages/admin/AdminSidebar/styles.ts